import { render, staticRenderFns } from "./TgbTabs.vue?vue&type=template&id=723012c2&scoped=true"
import script from "./TgbTabs.vue?vue&type=script&lang=js"
export * from "./TgbTabs.vue?vue&type=script&lang=js"
import style0 from "./TgbTabs.vue?vue&type=style&index=0&id=723012c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723012c2",
  null
  
)

export default component.exports